import { createAppRules } from '../ability';

export const PROSTHETIST_RULES = createAppRules(() => {
	//
});
